import {initVolgaCliffPhonesEffects} from "../components/phones-effects";

export function initVolgaCliffLanding() {
    if (!$('#volgacliff_landing').length) return;

    initVolgaCliffPhonesEffects();

    console.log('volga work')
}
